import React, { ReactElement } from 'react';

export const FetchError = (): ReactElement => {
  return (
    <div className="error-message">
      <span className="text">Something went wrong, please try again...</span>
    </div>
  );
};
